import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import type { UsersAndContacts } from '@/types/contacts'
import { getAvatarProps } from '@/utils/avatarUtils'

interface RoundedFriendsItemProps {
  contact: UsersAndContacts
  onPress: (contact: UsersAndContacts) => void
  isSelected?: boolean
  isMultiSelectMode?: boolean
}

export const RoundedFriendsItem: React.FC<RoundedFriendsItemProps> = ({
  contact,
  onPress,
  isSelected = false,
  isMultiSelectMode = false,
}) => {
  const avatarProps = getAvatarProps({
    first_name: contact.first_name,
    last_name: contact.last_name,
    avatar_path: contact.avatar_path,
    avatarBg: contact.avatarBg,
    id: contact.id,
  })

  const displayName = contact.first_name || contact.username || 'Unknown'

  const handlePress = () => {
    onPress(contact)
  }

  return (
    <BaseView
      className="cursor-pointer hover:opacity-90 active:scale-95 transition-all duration-150 ease-out"
      style={{
        alignItems: 'center',
        gap: '8px',
        width: '88px', // Фиксированная ширина для сокращения текста
        flexDirection: 'column',
        position: 'relative',
      }}
      onClick={handlePress}
    >
      {/* Avatar - точно как в RN версии */}
      <BaseView style={{ position: 'relative' }}>
        <Avatar
          size={68}
          initials={avatarProps.initials}
          imageUrl={avatarProps.avatarUrl}
          gradientColors={avatarProps.backgroundGradient}
          fullSize={false}
        />
        {/* Selection indicator overlay */}
        {isMultiSelectMode && isSelected && (
          <BaseView
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '24px',
              height: '24px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="2"
                width="28"
                height="28"
                rx="14"
                fill="url(#paint0_linear_38805_29633)"
              />
              <rect
                x="2"
                y="2"
                width="28"
                height="28"
                rx="14"
                stroke="#131415"
                stroke-width="4"
              />
              <path
                d="M14.6645 18.1139L20.3214 12.4571C20.5817 12.1967 21.0038 12.1967 21.2642 12.4571C21.5245 12.7174 21.5245 13.1395 21.2642 13.3999L15.3716 19.2924C14.9811 19.683 14.3479 19.683 13.9574 19.2924L10.8933 16.2283C10.6329 15.968 10.6329 15.5459 10.8933 15.2855C11.1536 15.0252 11.5757 15.0252 11.8361 15.2855L14.6645 18.1139Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_38805_29633"
                  x1="-0.923077"
                  y1="21.3333"
                  x2="28.032"
                  y2="29.203"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#7866FF" />
                  <stop offset="1" stop-color="#4732FF" />
                </linearGradient>
              </defs>
            </svg>
          </BaseView>
        )}
      </BaseView>

      {/* Name - точно как в RN версии */}
      <BaseText
        className="truncate"
        fontSize={18}
        fontFamily="medium"
        color="#E9E9E9"
        style={{
          textAlign: 'center',
          lineHeight: 'normal',
          margin: 0,
          width: '80px', // Ограничиваем ширину для сокращения
          maxWidth: '80px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {displayName}
      </BaseText>
    </BaseView>
  )
}

export default RoundedFriendsItem
